import React from "react";
import translate from "react-i18next/dist/commonjs/translate";

const IncidentsBecomePlusCustomer = ({ t }) => (
  <div className="container informationContainer">
    <h4 className="primaryColorHeader">{t("incidentsWidgetButtonText")}</h4>
    <p className="plusCustomerParagraph">
      {t("incidentsBecomePlusCustomerP1")}
    </p>
    <p className="plusCustomerParagraph">
      {t("incidentsBecomePlusCustomerP2")}{" "}
    </p>
  </div>
);

export default translate("translations")(IncidentsBecomePlusCustomer);



// WEBPACK FOOTER //
// ./src/incidents/IncidentsBecomePlusCustomer.js